import { localizedRevenueShareOfferingStatus } from "../../intl/shared-resources/revenueShareOfferingStatus.js";
import { ChipVariant, ChipType } from "../../components/chip/types.js";
import "../../components/icons/Icon.js";
import "react";
import { CustomIcon } from "../../components/icons/types.js";
import "../../components/icons/ExpandMoreIcon.js";
import { RevenueShareOfferingStatus } from "../../contract/pam.js";
const getRevenueShareOfferingStatusChipsMapping = () => ({
  [RevenueShareOfferingStatus.Active]: {
    label: localizedRevenueShareOfferingStatus[RevenueShareOfferingStatus.Active],
    chipType: ChipType.Mark,
    chipVariant: ChipVariant.LightGreen,
    startIconClass: CustomIcon.Target
  },
  [RevenueShareOfferingStatus.Inactive]: {
    label: localizedRevenueShareOfferingStatus[RevenueShareOfferingStatus.Inactive],
    chipType: ChipType.TagMark,
    chipVariant: ChipVariant.Disabled,
    startIconClass: CustomIcon.Block
  }
});
export {
  getRevenueShareOfferingStatusChipsMapping
};
//# sourceMappingURL=revenueShareOfferingStatusChipConfig.js.map
